<template>
<input class="form-control" v-model="texto"
       :type="type"
       @keyup="change" @change="change" />
</template>

<script>
    export default {
        name: "Input",
        model: {
            prop: 'input',
            event: 'search'
        },
        props: {
            input: [String, Boolean],
            type: {
                default: "text"
            },
        },
        data() {
            return {
                texto: ''
            }
        },
        methods: {
            change: function () {
                this.$emit('search', this.texto);
            }
        }
    }
</script>

<style scoped>

</style>